import { client } from "helper/apolloConfig";
import {
  downloadScoreRoomGQL,
  getAndDownloadAwaitedTrialForDraw,
  downloadRandomDogsTrialByTrialCalendar,
  generateStickersPdfQuery,
} from "redux/features/reports/reportsGql";
import { handleDownload } from "helper/utils";

export const DownloadAwaitedTrialForDraw = async (trialCalenderId) => {
  const result = await client.query({
    query: getAndDownloadAwaitedTrialForDraw,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.getAndDownloadAwaitedTrialForDraw;
  // await handleDownload(data?.downloadUrl);
  window.open(data?.downloadUrl, "_blank");
  return data;
};

export const DownloadEntriesForDraw = async (trialCalenderId) => {
  const result = await client.query({
    query: downloadRandomDogsTrialByTrialCalendar,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.downloadRandomDogsTrialByTrialCalendar;
  window.open(data?.downloadUrl, "_blank");
  return data;
};

export const DownloadScoreRoom = async (trialCalenderId) => {
  const result = await client.query({
    query: downloadScoreRoomGQL,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.getAllScoreList;
   window.open(data?.downloadUrl, "_blank");
  // await handleDownload(data?.downloadUrl);
  return data;
};

export const DownloadStickers = async (trialCalenderId) => {
  const result = await client.query({
    query: generateStickersPdfQuery,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.generateStickersPdf;
  window.open(data?.url, "_blank");
  return data;
};
